import { render, staticRenderFns } from "./bankrupt-due-rights-form.vue?vue&type=template&id=69982811&scoped=true&"
import script from "./bankrupt-due-rights-form.vue?vue&type=script&lang=js&"
export * from "./bankrupt-due-rights-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69982811",
  null
  
)

export default component.exports